export default {
  systemSybol: '---admin_qy',
  set (key, value) {
    localStorage.setItem(key + this.systemSybol, JSON.stringify(value))
  },
  get (key) {
    const val = localStorage.getItem(key + this.systemSybol)
    if (val !== undefined && val !== 'undefined') {
      return JSON.parse(val)
    }
    return null
  },
  remove (key) {
    localStorage.removeItem(key + this.systemSybol)
  },
  clear () {
    const storageLength = localStorage.length
    let deleteIndex = 0
    for (let i = 0; i < storageLength; i += 1) {
      if (
        localStorage.key(deleteIndex) &&
        localStorage.key(deleteIndex).indexOf(this.systemSybol) !== -1
      ) {
        localStorage.removeItem(localStorage.key(deleteIndex))
      } else {
        deleteIndex += 1
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/utils/storage.js